import React, { Component } from 'react'
import { RiEdit2Fill } from "react-icons/ri";
import { Link } from 'react-router-dom';
import axios from 'axios'
import user from '../../actions/user'
import purchasedPack from '../../actions/purchasedPack'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent';
import ApiSso from '../../actions/sso';
import TablePayments from '../../components/TablePayments/TablePayments';


class Dashboard extends Component {
    constructor(props){
        super(props);

        this.state = {
            isLoading: true,
            paymentList: [],
            uri: ''
        }
    }

    async validatePurshasedPack() {
        return await purchasedPack.purchasedPackValidate();
    }

    async validateToken() {
        return await user.tokenValidate();
    }

    async componentDidMount() {

        this.setState({ isLoading: false });

        if(localStorage.getItem('payment-success')){

            window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            window.dataLayer.push({
            'ecommerce': {
                'purchase': {
                'actionField': {
                    'id': localStorage.getItem('cart').toUpperCase(),  
                    'revenue': localStorage.getItem('user_plan_price')
                },
                'products': [
                        {        
                        'name': localStorage.getItem('user_plan_name'),
                        'id': localStorage.getItem('user_plan_id'),
                        'price': localStorage.getItem('user_plan_price'),
                        'quantity': 1
                        }
                    ]
                }
            }
            });

        }

        ApiSso.post('/auth-string', {
            "id": localStorage.getItem('user'),
            "email": localStorage.getItem('user_email'),
            "membership": "ouro",
            "member_card": ""
        }).then((response) => {
            this.setState({
                uri: 'https://figueirasaude.com.br/acesso?user_data='+response.data.data.encrypted_value+'&iv='+response.data.data.iv
            })
        });

        Promise.all([this.validatePurshasedPack(), this.validateToken()])
        .then(responses => {
            if (responses[0].data.data.status) {
                
                // Deu certo, encontrou pacote pago pelo usuário
                
                purchasedPack.getPurchaseHistory().then(response => {
                    console.log(response)
                    // console.log(response.data.userPayments.data)

                    // this.setState({
                    //     paymentList: res.data.userPayments.data
                    // })
                })

                this.setState({ isLoading: false });
            } else {
                // Deu errado
                this.props.history.replace('/');
            }

        }).catch(errors => {
            // Registrou porém sem pacote
            if (errors.response.status === 404) {
                this.props.history.replace('/payment');
            } else {
                localStorage.removeItem('token');
                this.props.history.replace('/login');
            }
        })
    }

    render(){ 

        return(
            <div className="page-container page">

                {this.state.isLoading ? <LoadingComponent /> : <></>}

                <div className="position-relative">
                    <div className="p-5">
                        <a href={this.state.uri} target="_blank" className="btn-apointment">Iniciar atendimento</a>

                        <div className="row mb-3">
                            <div className="col-12 col-sm-12">
                                <Link to="/dashboard/plan/">
                                    <div className="box-dashboard">
                                        <small>Plano</small>
                                        <h5>Configurações</h5>
                                        <RiEdit2Fill />
                                    </div>
                                </Link>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        )

    }
}

export default Dashboard